<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <!-- :class="{ disabled_input: disabled }" -->
    <div class="input_wrapper top_label select_wrapper" style="display: block">
      <label class="form-label">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <v-pagination-select
        class="select_group"
        :options="countries"
        label="name"
        :value="value"
        @input="updateValue($event)"
        :reduce="option => option.id"
        :filterable="true"
      @search="onSearch"
      >
        <li slot="list-footer" class="pagination">
          <button
            :disabled="currentPage === 1"
            @click.prevent="goToPage(currentPage - 1)"
          >
            &laquo;
          </button>
          <button
            v-for="page in visiblePages"
            :key="page"
            :disabled="page === currentPage"
            @click.prevent="goToPage(page)"
          >
            {{ page }}
          </button>
          <button
            :disabled="currentPage === total"
            @click.prevent="goToPage(currentPage + 1)"
          >
            &raquo;
          </button>
        </li>
      </v-pagination-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasePaginatedSelect',
  props: ['api_sport_id','type','value', 'label','col','required','placeholder'],
  data: () => ({
    countries: [],
    url:"",
    selectedValue: 0,
    search: "",
    limit: 50,
    pageWindowStart: 1,
    pageWindowSize: 5,
    currentPage: 1,
    total: 1,
  }),
  computed: {
    visiblePages() {
      const end = Math.min(this.pageWindowStart + this.pageWindowSize - 1, this.total);
      const length = Math.max(0, end - this.pageWindowStart + 1);
      return Array.from({length}, (_, i) => this.pageWindowStart + i);
    }
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e);
      console.log(e);
    },
    async getCountries(page = 1) {
      if (!this.api_sport_id){
        return;
      }
      if(this.type=='league') {
        this.url="soccer-leagues";
      } else if(this.type=='team') {
        this.url="soccer-teams";
      }
      try {
        let res = await
          this.$axios({
            method: "GET",
            url: this.url,
            params: {
              page: page,
              sport_id: this.api_sport_id ?? 1,
            },
          });
        this.countries = res.data.data.res.data;
        this.total = res.data.data.res.meta.pages;
        this.currentPage = page;
      } catch (error) {
      }
    },
    onSearch(query) {
      // this.search = query;
      // this.getCountries(1); // Reset to page 1 when searching

     
        this.search = query;
        this.offset = 0
    },
    goToPage(page) {
      if (page >= 1 && page <= this.total) {
        this.getCountries(page);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.pagination button:disabled {
  font-weight: bold;
  cursor: default;
  background: blue;
  color: #fff;
}

.pagination button:hover {
  cursor: pointer;
  background: blue;
  color: #fff;
}

.select_group {
  button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid blue;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
</style>